

<section class="f-img h-screen py-36  justify-center relative overflow-hidden bg-no-repeat bg-center bg-cover">

  <div class="absolute inset-0 bg-gradient-to-b from-[transparent] to-earth-try"></div>

  <section class="absolute top-0 py-4 md:py-16 px-4 md:px-48 overflow-hidden bg-no-repeat bg-center bg-cover w-full">
    <div class="float-left text-left">
      <h3 class="text-earth-dark">MUDICO</h3>
      <span class="text-earth-dark">Multi Disciplinair Centrum voor Ontwikkeling</span>
    </div>

    <div class="hidden md:block float-left md:float-right text-left md:text-right socials px-0 md:px-2 py-4 md:py-2">
      <ul class="list-none text-center">
        <li class="inline"><a href="https://www.facebook.com/mudico1" target="_blank" class="btn btn-icon btn-lg md:btn-sm border-2 text-earth-dark border-earth-dark rounded-md hover:bg-earth-try text-xl md:text-md"><i class="uil uil-facebook-f align-middle" title="facebook"></i></a></li>
        <li class="inline"><a href="https://www.instagram.com/groepspraktijk_mudico/" target="_blank" class="btn btn-icon btn-lg md:btn-sm border-2 text-earth-dark border-earth-dark rounded-md hover:bg-earth-try ml-2 text-xl md:text-md"><i class="uil uil-instagram align-middle" title="instagram"></i></a></li>
      </ul>
    </div>
  </section>



  <div class="container px-0 mx-0 pl-4 md:pl-48 relative z-3 hidden md:block">
      <div class="grid grid-cols-4">
          <div class="flex flex-col min-h-screen justify-left md:px-0 py-0 px-4">

              <div class="title-heading text-left md:text-left my-0 md:my-8 pt-0 md:pt-16">
                <h3 class="text-earth-dark mt-3 md:mt-6 mb-3 md:text-3xl text-2xl font-bold">MUDICO Lanaken</h3>
                <p><i class="uil uil-map-marker"></i> <span class='ml-2'>Heirbaan 271 - 3621 Lanaken</span></p>
                <p><i class="uil uil-phone"></i> <span class='ml-2'>0486 52 41 62</span></p>
                <p><i class="uil uil-envelope"></i> <span class='ml-2'><a href='mailto:lanaken@mudico.be'>lanaken@mudico.be</a></span></p>

                <h3 class="text-earth-dark mt-3 md:mt-6 mb-3 md:text-3xl text-2xl font-bold">MUDICO As</h3>
                <p><i class="uil uil-map-marker"></i> <span class='ml-2'>Breeërweg 3 - 3665 As</span></p>
                <p><i class="uil uil-phone"></i> <span class='ml-2'>0473 60 13 11</span></p>
                <p><i class="uil uil-envelope"></i> <span class='ml-2'><a href='mailto:as@mudico.be'>as@mudico.be</a></span></p>
              </div>

          </div>
          <div class="flex flex-col min-h-screen justify-left md:px-0 py-0 px-4">
            <div class="title-heading text-left md:text-left my-0 md:my-8 pt-0 md:pt-16">
              <h3 class="text-earth-dark mt-3 md:mt-6 mb-3 md:text-3xl text-2xl font-bold">MUDICO Diest</h3>
                <p><i class="uil uil-map-marker"></i> <span class='ml-2'>Grasbos 70 - 3294 Diest</span></p>
                <p><i class="uil uil-phone"></i> <span class='ml-2'>0495 20 70 77</span></p>
                <p><i class="uil uil-envelope"></i> <span class='ml-2'><a href='mailto:diest@mudico.be'>diest@mudico.be</a></span></p>

                <h3 class="text-earth-dark mt-3 md:mt-6 mb-3 md:text-3xl text-2xl font-bold">MUDICO Wellen</h3>
                <p><i class="uil uil-map-marker"></i> <span class='ml-2'>Bosstraat 24 - 3830 Wellen</span></p>
                <p><i class="uil uil-phone"></i> <span class='ml-2'>0469 22 86 90</span></p>
                <p><i class="uil uil-envelope"></i> <span class='ml-2'><a href='mailto:wellen@mudico.be'>wellen@mudico.be</a></span></p>
              </div>
          </div>
      </div>
  </div>

  <div class="container px-0 mx-0 pl-4 md:pl-48 relative z-3 block md:hidden -mt-8">
    <div class="grid grid-cols-1">
        <div class="flex flex-col min-h-screen justify-left md:px-0 py-0 px-2">

            <div class="title-heading text-left md:text-left my-0 md:my-8 pt-0 md:pt-16">
              <h3 class="text-earth-dark mt-3 md:mt-6 mb-3 md:text-3xl text-xl font-bold">MUDICO Lanaken</h3>
              <p><i class="uil uil-map-marker"></i> <span class='ml-2'>Heirbaan 271 - 3621 Lanaken</span></p>
              <p><i class="uil uil-phone"></i> <span class='ml-2'>0486 52 41 62</span></p>
              <p><i class="uil uil-envelope"></i> <span class='ml-2'><a href='mailto:lanaken@mudico.be'>lanaken@mudico.be</a></span></p>

              <h3 class="text-earth-dark mt-3 md:mt-6 mb-3 md:text-3xl text-xl font-bold">MUDICO As</h3>
              <p><i class="uil uil-map-marker"></i> <span class='ml-2'>Breeërweg 3 - 3665 As</span></p>
              <p><i class="uil uil-phone"></i> <span class='ml-2'>0473 60 13 11</span></p>
              <p><i class="uil uil-envelope"></i> <span class='ml-2'><a href='mailto:as@mudico.be'>as@mudico.be</a></span></p>

              <h3 class="text-earth-dark mt-3 md:mt-6 mb-3 md:text-3xl text-xl font-bold">MUDICO Diest</h3>
              <p><i class="uil uil-map-marker"></i> <span class='ml-2'>Grasbos 70 - 3294 Diest</span></p>
              <p><i class="uil uil-phone"></i> <span class='ml-2'>0495 20 70 77</span></p>
              <p><i class="uil uil-envelope"></i> <span class='ml-2'><a href='mailto:diest@mudico.be'>diest@mudico.be</a></span></p>

              <h3 class="text-earth-dark mt-3 md:mt-6 mb-3 md:text-3xl text-xl font-bold">MUDICO Wellen</h3>
              <p><i class="uil uil-map-marker"></i> <span class='ml-2'>Bosstraat 24 - 3830 Wellen</span></p>
              <p><i class="uil uil-phone"></i> <span class='ml-2'>0469 22 86 90</span></p>
              <p><i class="uil uil-envelope"></i> <span class='ml-2'><a href='mailto:wellen@mudico.be'>wellen@mudico.be</a></span></p>
            </div>
        </div>
    </div>
</div>

  <section class="absolute bottom-0 p-4 w-full footer">
    <div class="block md:hidden text-center socials px-0 md:px-2 py-4 md:py-2">
      <ul class="list-none text-right">
        <li class="inline"><a href="https://www.facebook.com/mudico1" target="_blank" class="btn btn-icon btn-lg md:btn-sm border-2 text-earth-dark border-earth-dark rounded-md hover:bg-earth-try text-xl md:text-md"><i class="uil uil-facebook-f align-middle" title="facebook"></i></a></li>
        <li class="inline"><a href="https://www.instagram.com/groepspraktijk_mudico/" target="_blank" class="btn btn-icon btn-lg md:btn-sm border-2 text-earth-dark border-earth-dark rounded-md hover:bg-earth-try ml-2 text-xl md:text-md"><i class="uil uil-instagram align-middle" title="instagram"></i></a></li>
      </ul>
    </div>

    <div class="text-center">
      <p class="mb-0 font-medium text-earth-common/70">© {{ year }} MUDICO</p>
    </div>
  </section>
</section>
